/** 
 * @type {import("./defs").StoreAsset} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreAsset} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreAsset.js